(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fd-hero-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const frames = document.querySelectorAll('[data-fd-hero-video]');
    if (!frames.length || !('IntersectionObserver' in window)) return;

    const obs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const frame = entry.target;
          const video = frame.querySelector('[data-fd-hero-video-el]');
          if (!video) return;

          if (entry.isIntersecting) {
            if (!video.src && video.dataset.src) {
              video.src = video.dataset.src;
              video.addEventListener(
                'loadeddata',
                () => video.classList.add('is-ready'),
                { once: true }
              );
            }
            const playPromise = video.play();
            if (playPromise && playPromise.catch) playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.4, rootMargin: '200px 0px' }
    );

    frames.forEach((f) => obs.observe(f));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fd-video-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (!('IntersectionObserver' in window)) return;

    const cards = document.querySelectorAll('[data-fd-vc]');
    if (!cards.length) return;

    const visibilityObs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target.querySelector('[data-fd-vc-video]');
          if (!video) return;

          if (entry.isIntersecting) {
            if (!video.src && video.dataset.src) {
              video.src = video.dataset.src;
              video.addEventListener(
                'loadeddata',
                () => video.classList.add('is-ready'),
                { once: true }
              );
            }
            const p = video.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.5, rootMargin: '100px 0px' }
    );

    cards.forEach((card) => {
      visibilityObs.observe(card);

      const video = card.querySelector('[data-fd-vc-video]');
      const sound = card.querySelector('[data-fd-vc-sound]');
      if (!video || !sound) return;

      const toggle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        video.muted = !video.muted;
        sound.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        if (!video.muted && video.paused) {
          const p = video.play();
          if (p && p.catch) p.catch(() => {});
        }
      };

      sound.addEventListener('click', toggle);
      video.addEventListener('click', toggle);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
